import { IOLPay } from './shim';

export const initIolPay = () => {
	const shim = new IOLPay();
	(window as any).iolpay = {};
	(window as any).iolpay.init = shim.init.bind(shim);
	(window as any).iolpay.submitPayment = shim.submitPayment.bind(shim);
	// (window as any).iolpay.subscribe = shim.subscribe.bind(shim);
	// (window as any).iolpay.unsubscribe = shim.unsubscribe.bind(shim);
	(window as any).iolpay.unmountIframe = shim.unmountIframe.bind(shim);
};

export const getIolPay = (): IOLPay => (window as any).iolpay as IOLPay;

export const destroyIolPay = () => {
	if ((window as any).iolpay) {
		((window as any).iolpay as IOLPay).unmountIframe();
	}
};
